import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DilysuAilgyfeirioComponent } from './dilysu-ailgyfeirio/dilysu-ailgyfeirio.component';
import { AllgofnodiAilgyfeirioComponent } from './allgofnodi-ailgyfeirio/allgofnodi-ailgyfeirio.component';
import { UiModule } from '../ui/ui.module';

@NgModule({
    imports: [
        CommonModule,
        UiModule,
        DilysuAilgyfeirioComponent, AllgofnodiAilgyfeirioComponent
    ]
})
export class DilysuModule { }
